import React, {useMemo} from "react";
import {CreditsListsItemsDataGridCellKeys,} from "../../../../../../../../../core/constants/table/data-grid-column-keys";
import {DataGridColumnAlignments, DataGridColumnTypes, useDataGridSavedState} from "../../../../../../../../../packages/data-grid";
import IconButton from "../../../../../../../../components/base/button/icon_button";
import {OpenInNew} from "@mui/icons-material";
import PartnerDataGrid from "../../../../../../../../containers/data-grid";
import useAccessLevels from "../../../../../../../../hooks/use-access-levels";
import ProductInformationPopover from "../../../../../../../../components/app-specific/draggable-popover/product-information-popover";
import {ReactComponent as Printer} from "../../../../../../../../../assets/images/printer.svg";
import {CircularProgress, SvgIcon} from "@mui/material";


const CreditsListViewItemsTable = ({
                                       searchData,
                                       exportToCsv,
                                       data,
                                       dataGridSaveConfig,
                                       navigateToInformationView,
                                       navigateToPrintView,
                                       fetchingOrdersCustomer,
                                   }) => {
    const operatorAccessLevels = useAccessLevels();

    const columns = useMemo(() =>
        /** @type {DataGridColumn[]}*/
        [
            ...(operatorAccessLevels.packages.sales.creditInformation ? [
                {
                    name: CreditsListsItemsDataGridCellKeys.navigate,
                    alignment: DataGridColumnAlignments.center,
                    type: DataGridColumnTypes.element,
                    pinned: true,
                    sortable: false,
                    pinnedToggleable: false,
                    resizable: false,
                    visibilityToggleable: false,
                    width: 0,
                },
                ...(operatorAccessLevels.packages.bizPrint.printCredit ? [
                    {
                        name: CreditsListsItemsDataGridCellKeys.print,
                        alignment: DataGridColumnAlignments.center,
                        type: DataGridColumnTypes.element,
                        pinned: true,
                        sortable: false,
                        pinnedToggleable: false,
                        resizable: false,
                        visibilityToggleable: false,
                        width: 0,
                    },
                ] : []),
            ] : []),
            {
                title: "Invoice No",
                name: CreditsListsItemsDataGridCellKeys.orderNo,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
                pinned: true,
            },
            {
                title: "Customer",
                name: CreditsListsItemsDataGridCellKeys.customer,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.string,
            },
            {
                title: "Part No",
                name: CreditsListsItemsDataGridCellKeys.partNo,
                alignment: DataGridColumnAlignments.center,
                type: DataGridColumnTypes.element,
            },
            {
                title: "Invoice Date",
                name: CreditsListsItemsDataGridCellKeys.submitDate,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.date,
            },
            {
                title: "Unit Price",
                name: CreditsListsItemsDataGridCellKeys.unitPrice,
                alignment: DataGridColumnAlignments.right,
                type: DataGridColumnTypes.money,
            },
            {
                title: "Order Qty",
                name: CreditsListsItemsDataGridCellKeys.orderQty,
                alignment: DataGridColumnAlignments.left,
                type: DataGridColumnTypes.number,
            },
        ], [operatorAccessLevels.packages.bizPrint.printCredit, operatorAccessLevels.packages.sales.creditInformation])

    const [dataGridColumns, , , dataGridDensity] = useDataGridSavedState({
        columns: columns,
        version: dataGridSaveConfig.version,
        name: dataGridSaveConfig.name,
    });

    /**@type {DataGridRow[]}*/
    const dataGridRows = useMemo(() => {
        return data?.map(item => ({
            key: item.id,
            data: item,
            cells: {
                [CreditsListsItemsDataGridCellKeys.navigate]:
                    <IconButton
                        color={'secondary'}
                        disabled={fetchingOrdersCustomer.includes(item.orderId)}
                        onClick={() => navigateToInformationView(item.customer, item.orderId)}
                    >
                        {
                            fetchingOrdersCustomer.includes(item.orderId)
                                ? <CircularProgress size={20} color={'secondary'}/>
                                : <OpenInNew className='icon normal'/>
                        }
                    </IconButton>,
                [CreditsListsItemsDataGridCellKeys.print]:
                    <IconButton
                        disabled={fetchingOrdersCustomer.includes(item.orderId)}
                        color={'paper.secondary'}
                        onClick={() => navigateToPrintView(item.customer, item.orderId)}
                    >
                        {
                            fetchingOrdersCustomer.includes(item.orderId)
                                ? <CircularProgress size={20} color={'secondary'}/>
                                : <SvgIcon className='icon medium' component={Printer}/>
                        }
                    </IconButton>,
                [CreditsListsItemsDataGridCellKeys.orderNo]: item.orderNo,
                [CreditsListsItemsDataGridCellKeys.customer]: item.customer?.name,
                [CreditsListsItemsDataGridCellKeys.partNo]:
                    <ProductInformationPopover partNo={item.partNo}>
                        {item.partNo ?? ""}
                    </ProductInformationPopover>,
                [CreditsListsItemsDataGridCellKeys.submitDate]: item.createdDate,
                [CreditsListsItemsDataGridCellKeys.unitPrice]: item.unitPrice,
                [CreditsListsItemsDataGridCellKeys.orderQty]: item.orderQty,
            }
        }))
    }, [data, fetchingOrdersCustomer, navigateToInformationView, navigateToPrintView])

    return (
        <>
            <PartnerDataGrid
                {...dataGridSaveConfig}
                initialLayoutState={{
                    columns: columns,
                }}
                columns={dataGridColumns}
                rows={dataGridRows}
                state={{
                    pagination: searchData.paginationInfo,
                    sortBy: searchData.orderBy,
                    loading: {state: searchData.loading},
                    density: dataGridDensity,
                }}
                hideFooterActions
                getExportInfo={exportToCsv}
                onSortByChanged={(_, current) => searchData.setOrderBy(current)}
                onCurrentPageChanged={(_, current) => searchData.setPaginationInfo(prevState => ({...prevState, ...current}))}
                onPageSizeChanged={(_, current) => searchData.setPaginationInfo(prevState => ({...prevState, ...current}))}
            />
        </>
    );
}
export default CreditsListViewItemsTable;
